import React from 'react'

import ContactIcon from '../RouterProject/Contact.svg'
const Contact = () => {
  return (
    <>
   <div className="contact">
    <h1>Contact--page</h1>
    <div className="image">
    <img src={ContactIcon} alt="Home" className='img'/>
<p className='my-4 text-md-start pra'>Contact dolor, sit amet consectetur adipisicing elit. Ipsa nam nostrum at. Facere aperiam exercitationem, quia delectus blanditiis vel necessitatibus voluptatem eligendi in minus, accusamus hic, culpa rem nisi! Esse?Home dolor, sit amet consectetur adipisicing elit. Ipsa nam nostrum at. Facere aperiam exercitationem, quia delectus blanditiis vel necessitatibus voluptatem eligendi in minus, accusamus hic, culpa rem nisi! Esse?</p>
    </div>
   </div>
    </>
  )
}

export default Contact